var _g, _rect, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_8089_334593)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.09473,
    y: 16,
    width: 29.0655,
    height: 18.1659,
    rx: 9.08297,
    fill: "url(#paint0_linear_8089_334593)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.21387,
    y: 0.213867,
    width: 31.4876,
    height: 31.4876,
    rx: 6,
    fill: "url(#paint1_linear_8089_334593)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8089_334593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1966 17.1726L25.7227 13.7766H22.4818V11.5693C22.4818 10.6407 22.9343 9.73333 24.3811 9.73333H25.8753V6.84145C25.0052 6.70048 24.1259 6.62422 23.2447 6.61328C20.5772 6.61328 18.8357 8.24228 18.8357 11.1872V13.7766H15.8789V17.1726H18.8357V25.3866H22.4818V17.1726H25.1966Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8089_334593",
    x: 0.634727,
    y: 10.54,
    width: 39.9854,
    height: 29.086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73,
    result: "effect1_foregroundBlur_8089_334593"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8089_334593",
    x1: 20.6275,
    y1: 33.6352,
    x2: 20.6275,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8089_334593",
    x1: 20.9577,
    y1: 30.7815,
    x2: 20.9577,
    y2: 0.213867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8089_334593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(11.1865 6.18652)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2ef3004a69cc334a83b3a8694b480666.svg";
export { ForwardRef as ReactComponent };